import { apiWrapper } from "@/services/api";
import store from "@/store/index";

export const getSheet = async (id) => {
  try {
    const resp = await apiWrapper("GET", `sheets/${id}`);
    store.commit("setSheet", resp.data);
  } catch (err) {
    console.log("ERROR!!! getSheet");
    throw err;
  }
};
